import React from "react";
import { Props } from "./types";

function TagIcon({ className }: Props) {
  return (
    <svg className={className} viewBox="0 0 40.001 33">
      <g
        id="rawpixel-990040-unsplash"
        fill="none"
        stroke="#b9b9b9"
        strokeWidth="1"
        strokeDasharray="5"
      >
        <circle cx="16.5" cy="16.5" r="16.5" stroke="none" />
        <circle cx="16.5" cy="16.5" r="16" fill="none" />
      </g>
      <path
        d="M7.273,0A7.273,7.273,0,1,1,0,7.273,7.273,7.273,0,0,1,7.273,0Z"
        transform="translate(25.455 10.182)"
        fill="#b9b9b9"
      />
      <text
        transform="translate(29 21)"
        fill="#fff"
        fontSize="14"
        fontFamily="Quicksand-Medium, Quicksand"
        fontWeight="500"
        letterSpacing="-0.024em"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
      <g transform="translate(10.402 11.357)">
        <g transform="translate(0 0)">
          <path
            d="M.36,5.84,5.844.357A1.227,1.227,0,0,1,6.706,0h4.268a1.219,1.219,0,0,1,1.219,1.219V5.487a1.206,1.206,0,0,1-.36.863L6.347,11.836a1.218,1.218,0,0,1-1.722,0L.357,7.569a1.222,1.222,0,0,1,0-1.728Zm9.7-2.792a.914.914,0,1,0-.915-.914A.913.913,0,0,0,10.06,3.048Z"
            transform="translate(0 0)"
            fill="#b9b9b9"
          />
        </g>
      </g>
    </svg>
  );
}

export { TagIcon };
